import { DragAndDropController } from './drag-and-drop.controller'

function dragAndDrop () {
  return {
    scope: {
      mainContent: '<',
      onDrop: '<',
      dropText: '@',
      collection: '<'
    },
    restrict: 'E',
    templateUrl: '/core/directives/drag-and-drop/drag-and-drop.html?$$REVISION$$',
    controller: DragAndDropController
  }
}

export { dragAndDrop }
